import parseDeeplinks from './parseDeeplinks';
import type { Deeplink } from './types';

/**
 * One-shot snapshot of the deeplink at module load. The router strips the URL
 * after handlers resolve; this snapshot is preserved so consumers (e.g.
 * useAutoGeneration deriving isDeeplinkSession across re-renders) can still
 * read it after cleanup.
 *
 * If a future feature needs to react to mid-session SDK navigation, do that
 * through an explicit navigation emitter — never by re-reading the URL.
 */
let snapshot: Deeplink | null = null;

export const getDeeplinkSnapshot = (): Deeplink => {
  if (snapshot === null) snapshot = parseDeeplinks();
  return snapshot;
};
